export default __webpack_public_path__ + "static/1216-40d12a2fca0604b26abf758b2daf76c7.gif";